import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProductOrder } from "../../../types/admin/productOrder.types";
import {
  getProductOrderByIds,
  getProductOrders,
  updateProductOrderStatus,
} from "../../../services/productOrder.service";

const initialState = {
  productOrders: [] as ProductOrder[],
};

export const getOrders = createAsyncThunk(
  "get/productOrders",
  async (
    {
      city,
      index,
      fromDate,
      toDate,
    }: {
      city?: string;
      fromDate?: string;
      toDate?: string;
      index?: number;
    },
    { rejectWithValue }
  ) => {
    const { data, error } = (await getProductOrders({
      city,
      fromDate,
      toDate,
      index: index || 20,
    })) as { data: { orders: ProductOrder[]; count: number }; error: any };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const getOrder = createAsyncThunk(
  "get/order",
  async ({ ids }: { ids: string[] }, { rejectWithValue }) => {
    const { data, error } = (await getProductOrderByIds(ids)) as {
      data: { orders: ProductOrder[] };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const updateOrderStatus = createAsyncThunk(
  "update/order/status",
  async (
    { _id, status }: { _id: string; status: string },
    { rejectWithValue }
  ) => {
    const { data, error } = (await updateProductOrderStatus(_id, status)) as {
      data: any;
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const orderSlice = createSlice({
  name: "productOrders",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.productOrders = action.payload.orders;
    });

    builder.addCase(getOrder.fulfilled, (state, action) => {
      action.payload.orders.forEach((order) => {
        const existingIndex = state.productOrders.findIndex(
          (o) => o._id === order._id
        );
        if (existingIndex !== -1) {
          state.productOrders[existingIndex] = order;
        } else {
          state.productOrders.push(order);
        }
      });
    });

    builder.addCase(updateOrderStatus.fulfilled, (state, action) => {
      const existingIndex = state.productOrders.findIndex(
        (b) => b._id === action.payload.order._id
      );
      if (existingIndex !== -1) {
        state.productOrders[existingIndex] = action.payload.order;
      }
    });
  },
});

export default orderSlice.reducer;
